export default __webpack_public_path__ + "static/media/dedicated_desk.232e8b7d.svg";